import type {
	Artifact,
	Chat,
	Message,
	MessageWithContents,
	PromptCategory
} from '@types'
import axios from 'axios'

import env from '../environments'

export async function createChat(title: string, welcome?: boolean | undefined) {
	const response = await axios.post(`${env.apiUrl}/chats/create`, {
		title,
		welcome
	})

	return response.data as Chat
}

export async function getChatMessages(id: string, limit?: number | undefined, offset?: number | undefined) {
	const response = await axios.get(`${env.apiUrl}/chats/${id}/messages`, {
		params: {
			offset,
			limit
		}
	})

	return response.data as MessageWithContents[]
}

export async function getChatArtifact(chatId: string, artifactId: string) {
	const response = await axios.get(`${env.apiUrl}/chats/${chatId}/artifacts/${artifactId}`)

	return response.data as Artifact
}

export async function getAllChats() {
	const response = await axios.get(`${env.apiUrl}/chats`)

	return response.data as Chat[]
}

export async function updateChatTitle(id: string, title: string) {
	await axios.put(`${env.apiUrl}/chats/${id}`, {
		title
	})
}

export async function deleteChat(id: string) {
	await axios.delete(`${env.apiUrl}/chats/${id}`)
}

export async function getMessage(id: string) {
	const response = await axios.get(`${env.apiUrl}/chats/messages/${id}`)

	return response.data as Message
}

export async function sendMessage(
	chatId: string,
	brainsIds: string[],
	query: string,
	type: 'classic' | 'deepsearch' | 'followup',
	artifactQuery?: string | undefined,
	artifactId?: string | undefined,
	messageId?: string | undefined,
	contentIds?: string[] | undefined,
	isFollowUp?: boolean | undefined
) {
	const endpoint = `${env.apiUrl}/chats/${chatId}/completion`

	const payload = {
		query,
		brainsIds,
		type,
		artifactQuery,
		artifactId,
		messageId,
		contentIds,
		isFollowUp
	}

	const response = await axios.post(endpoint, payload)

	return response.data as {userMessage: Message; assistantMessage: Message}
}

export async function sendOpenBrainMessage(
	chatId: string,
	query: string,
	selectedOpenBrain: string,
	isReasoning: boolean
) {
	const response = await axios.get(`${env.apiUrl}/chats/${chatId}/completion/open-brain`, {
		params: {
			query,
			selectedOpenBrain,
			isReasoning
		}
	})

	return response.data as {userMessage: Message; assistantMessage: Message}
}

export async function rephrase(query: string, chatId: string) {
	const response = await axios.post(`${env.apiUrl}/chats/${chatId}/rephrase`, {
		query
	})

	return response.data as string
}

export async function getPromptsCategories() {
	const response = await axios.get(`${env.apiUrl}/chats/prompts`)

	return response.data as PromptCategory[]
}

export async function sendExhaustiveMessage(
	chatId: string,
	brainsIds: string[],
	query: string
) {
	const endpoint = `${env.apiUrl}/chats/${chatId}/completion_exhaustive`

	const payload = {
		query,
		brainsIds
	}

	const response = await axios.post(endpoint, payload)

	return response.data as {userMessage: Message; assistantMessage: Message}
}
